/* eslint-disable @typescript-eslint/no-explicit-any */

import { type JSX, useEffect, useState } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { type RouteComponentProps, withRouter } from 'react-router-dom';

import styled from 'styled-components';

import { Page } from '../../components';
import CardsAccordion from '../../components/CardsAccordion';
import { logger } from '../../features/logger';
import { withAPIService } from '../../networking';
import { withStore } from '../../store';

const CompanyCardWrapper = styled.div`
  margin-bottom: 24px;
`;

const WrapperContainer = styled.div`
  width: 100%;
`;

interface CompanyPageProps extends RouteComponentProps {
  store: any;
  cards?: any[];
  dispatch?: any;
}

function Component(props: CompanyPageProps): JSX.Element {
  const { store, cards = [] } = props;
  const { common } = store;
  const { policyAccepted } = common;

  const { t } = useTranslation();

  let finalCardList: any[] = [];

  const [expandedAccordion, setExpandedAccordion] = useState<any>(0);

  const [cardList, setCardList] = useState<any[]>([]);

  useEffect(() => {
    logger.info(`RED-CARPET-FE Company Page`, {
      hcRequestId: store.customer.id
    });

    filterCompanyPage();
  }, [policyAccepted]);

  const filterCompanyPage = () => {
    finalCardList = cards.filter((card: any) => {
      if (policyAccepted) {
        return card.key !== 'privacyPolicy';
      }
      return cards;
    });

    setCardList(finalCardList);
  };

  const accordionCallback = (index: number) => {
    setExpandedAccordion(index);
  };

  return (
    <>
      <Page {...props} dispatch={props.dispatch}>
        <WrapperContainer>
          {cardList.map(({ key, ...card }: any, index: number) => {
            const title = key === 'additionalAttachmentCard' ? t(`financial.${key}.title`) : t(`company.${key}.title`);

            const { Component } = card;

            const cardProps = {
              title: key === 'additionalAttachmentCard' ? t(`financial.${key}.subtitle`) : t(`company.${key}.subtitle`),
              formCompletionTime: t(`company.${key}.formCompletionTime`),
              image: '/food/onboarding/assets/Tooltip.svg'
            };

            return (
              <React.Fragment key={title}>
                {key === 'privacyPolicy' && policyAccepted ? null : (
                  <CompanyCardWrapper>
                    <CardsAccordion
                      accordionCallback={accordionCallback}
                      isOpen={expandedAccordion === index}
                      cardTitle={title}
                      cardIndex={index}
                      cardProps={cardProps}
                    >
                      <Component {...card} {...props} />
                    </CardsAccordion>
                  </CompanyCardWrapper>
                )}
              </React.Fragment>
            );
          })}
        </WrapperContainer>
      </Page>
    </>
  );
}
const connectRouter = withRouter(Component);
const connectAPI = withAPIService(connectRouter);
const CompanyPage = withStore(connectAPI);

export default CompanyPage;
